import { MaskitoOptions, MaskitoPreprocessor } from '@maskito/core';
import { maskitoDateOptionsGenerator, maskitoNumberOptionsGenerator } from '@maskito/kit';

export const mask_porcetagem = maskitoNumberOptionsGenerator({
  postfix: ' %',
  precision: 1,
  decimalSeparator: ',',
  decimalZeroPadding: true,
  min: 0,
  max: 100,
});

export const mask_porcetagem_duas_casas_decimais = maskitoNumberOptionsGenerator({
  postfix: ' %',
  precision: 2,
  decimalSeparator: ',',
  decimalZeroPadding: true,
  min: 0,
  max: 100,
});

export const mask_porcentagem_limpa = maskitoNumberOptionsGenerator({
  precision: 1,
  decimalSeparator: ',',
  decimalZeroPadding: true,
  min: 0,
  max: 100,
});

export const mask_porcentagem_limpa_duas_casas_decimais = maskitoNumberOptionsGenerator({
  precision: 2,
  decimalSeparator: ',',
  decimalZeroPadding: true,
  min: 0,
  max: 100,
});

export const mask_dinheiro = maskitoNumberOptionsGenerator({
  prefix: 'R$ ',
  decimalSeparator: ',',
  thousandSeparator: '.',
  decimalZeroPadding: true,
  precision: 2,
});

export const mask_dinheiro_limpo = maskitoNumberOptionsGenerator({
  decimalSeparator: ',',
  thousandSeparator: '.',
  decimalZeroPadding: true,
  precision: 2,
});

export const mask_nenhuma_casa_decimal = maskitoNumberOptionsGenerator({
  decimalSeparator: ',',
  decimalZeroPadding: true,
  thousandSeparator: '.',
  precision: 0,
})

export const mask_mes_ano = maskitoDateOptionsGenerator({
  mode: 'mm/yyyy',
  separator: '/',
});


export const mask_data = maskitoDateOptionsGenerator({
  mode: 'dd/mm/yyyy',
  separator: '/',
});

export const mask_duas_casas_decimais = maskitoNumberOptionsGenerator({
  precision: 2,
  decimalSeparator: ',',
  thousandSeparator: '.',
  decimalZeroPadding: true,
});
